/* istanbul ignore file */
import LayoutDescription from './LayoutDescription';

export default LayoutDescription;
